export const HOME_MATCH_PREFERENCES_WIZARD_CONTENT = {
    BACK: "Wstecz",
    BUDGET_DESCRIPTION: "Przesuń suwak lub wpisz maksymalną kwotę.",
    BUDGET_LABEL: "Maksymalna cena",
    BUDGET_PLACEHOLDER: "Kwota w zł",
    BUDGET_TITLE: "Ile chcesz przeznaczyć na mieszkanie?",
    LOCATION_APPLY: "Zapisz lokalizację",
    LOCATION_CANCEL: "Powrót",
    LOCATION_DESCRIPTION: "Wskazuj wybrane lokalizacje, a pokażemy Ci oferty z tej okolicy. Wybór możesz później zmienić.",
    LOCATION_LABEL: "Lokalizacja",
    LOCATION_NEXT_PLACEHOLDER: "| Wpisz kolejną lokalizację",
    LOCATION_PLACEHOLDER: "Miasto, dzielnica lub powiat",
    LOCATION_TITLE: "Gdzie szukasz mieszkania?",
    NEXT: "Dalej",
    SAVE: "Zapisz",
    SAVE_AND_EXIT: "Zapisz i wyjdź",
    PHONE_DESCRIPTION: "Wyślemy Ci SMS z kodem, który wpiszesz w następnym kroku. Dzięki temu potwierdzimy, że podany numer należy do Ciebie.",
    PHONE_PLACEHOLDER: "np. 123 456 789",
    PHONE_SUBMIT: "Wyślij kod SMS",
    PHONE_TITLE: "Podaj numer telefonu",
    PROGRESS: "Postęp konfiguracji",
    ROOMS_DESCRIPTION: "Wybierz liczbę pokoi. Dzięki temu lepiej dopasujemy oferty.",
    ROOMS_LABEL: "Liczba pokoi",
    ROOMS_TITLE: "Ile pokoi ma mieć mieszkanie?",
    COMPLETION_DATE_DESCRIPTION: "Wybierz, kiedy chcesz odebrać klucze, a pokażemy Ci inwestycje z pasującym terminem oddania.",
    SUMMARY: {
        BUDGET: "Budżet",
        CHANGE: "Zmień",
        CONFIRM: "Potwierdź",
        CONSENT_INTRO: "Włącz tę opcję, a dzięki niej:",
        CONSENT_ITEMS: [
            "Automatycznie wyślemy zapytania do deweloperów w Twoim imieniu.",
            "Deweloperzy będą mogli skontaktować się z Tobą z ofertami.",
            "O dopasowanych ofertach powiadomimy Cię SMS-em i e-mailem."
        ],
        DESCRIPTION: "Na podstawie tych kryteriów dopasujemy oferty. Możesz je później zmienić.",
        FINANCING_CASH: "zakup za gotówkę",
        FINANCING_CREDIT: "zakup na kredyt",
        APARTMENT: "Mieszkanie",
        HOUSE: "Dom",
        ANY_ROOMS: "Dowolna liczba pokoi",
        LOCATION: "Lokalizacja",
        TITLE: "Sprawdź swoje kryteria",
        TOGGLE: "Zapytania do deweloperów"
    },
    FINANCING: {
        CASH: "Za gotówkę",
        CREDIT: "Na kredyt",
        GROUP_LABEL: "Jak planujesz sfinansować zakup?",
        UNKNOWN: "Jeszcze nie wiem"
    },
    SMS: {
        CHANGE_NUMBER: "Zmień numer",
        CODE_INVALID: "Niepoprawna wartość",
        CONFIRM: "Potwierdź numer",
        CONTACT_OFFICE: "Skontaktuj się z naszym biurem obsługi:",
        DESCRIPTION: "Wpisz 4-cyfrowy kod z SMS-a wysłanego na",
        NO_CODE: "Nie otrzymałeś kodu?",
        RESEND: "Wyślij kod ponownie",
        RESEND_WAIT: "Możesz wysłać kod ponownie za",
        TITLE: "Potwierdź numer telefonu"
    },
    EXIT: {
        DESCRIPTION: "Możesz zapisać dotychczasowe odpowiedzi i wrócić do nich później.",
        RETURN: "Wróć do pytań",
        SAVE: "Zamknij i zapisz",
        TITLE: "Chcesz dokończyć później?"
    }
} as const;

export const getHomeMatchPreferencesWizardSmsDigitLabel = (position: number) => `Cyfra ${position} z 4`;
export const HOME_MATCH_PREFERENCES_WIZARD_CONTENT = {
    BACK: "Wstecz",
    BUDGET_DESCRIPTION: "Przesuń suwak lub wpisz maksymalną kwotę.",
    BUDGET_LABEL: "Maksymalna cena",
    BUDGET_PLACEHOLDER: "Kwota w zł",
    BUDGET_TITLE: "Ile chcesz przeznaczyć na mieszkanie?",
    LOCATION_APPLY: "Zapisz lokalizację",
    LOCATION_CANCEL: "Powrót",
    LOCATION_DESCRIPTION: "Wskazuj wybrane lokalizacje, a pokażemy Ci oferty z tej okolicy. Wybór możesz później zmienić.",
    LOCATION_LABEL: "Lokalizacja",
    LOCATION_NEXT_PLACEHOLDER: "| Wpisz kolejną lokalizację",
    LOCATION_PLACEHOLDER: "Miasto, dzielnica lub powiat",
    LOCATION_TITLE: "Gdzie szukasz mieszkania?",
    NEXT: "Dalej",
    SAVE: "Zapisz",
    SAVE_AND_EXIT: "Zapisz i wyjdź",
    PHONE_DESCRIPTION: "Wyślemy Ci SMS z kodem, który wpiszesz w następnym kroku. Dzięki temu potwierdzimy, że podany numer należy do Ciebie.",
    PHONE_PLACEHOLDER: "np. 123 456 789",
    PHONE_SUBMIT: "Wyślij kod SMS",
    PHONE_TITLE: "Podaj numer telefonu",
    PROGRESS: "Postęp konfiguracji",
    ROOMS_DESCRIPTION: "Wybierz liczbę pokoi. Dzięki temu lepiej dopasujemy oferty.",
    ROOMS_LABEL: "Liczba pokoi",
    ROOMS_TITLE: "Ile pokoi ma mieć mieszkanie?",
    COMPLETION_DATE_DESCRIPTION: "Wybierz, kiedy chcesz odebrać klucze, a pokażemy Ci inwestycje z pasującym terminem oddania.",
    SUMMARY: {
        BUDGET: "Budżet",
        CHANGE: "Zmień",
        CONFIRM: "Potwierdź",
        CONSENT_INTRO: "Włącz tę opcję, a dzięki niej:",
        CONSENT_ITEMS: [
            "Automatycznie wyślemy zapytania do deweloperów w Twoim imieniu.",
            "Deweloperzy będą mogli skontaktować się z Tobą z ofertami.",
            "O dopasowanych ofertach powiadomimy Cię SMS-em i e-mailem."
        ],
        DESCRIPTION: "Na podstawie tych kryteriów dopasujemy oferty. Możesz je później zmienić.",
        FINANCING_CASH: "zakup za gotówkę",
        FINANCING_CREDIT: "zakup na kredyt",
        APARTMENT: "Mieszkanie",
        HOUSE: "Dom",
        ANY_ROOMS: "Dowolna liczba pokoi",
        LOCATION: "Lokalizacja",
        TITLE: "Sprawdź swoje kryteria",
        TOGGLE: "Zapytania do deweloperów"
    },
    FINANCING: {
        CASH: "Za gotówkę",
        CREDIT: "Na kredyt",
        GROUP_LABEL: "Jak planujesz sfinansować zakup?",
        UNKNOWN: "Jeszcze nie wiem"
    },
    SMS: {
        CHANGE_NUMBER: "Zmień numer",
        CODE_INVALID: "Niepoprawna wartość",
        CONFIRM: "Potwierdź numer",
        CONTACT_OFFICE: "Skontaktuj się z naszym biurem obsługi:",
        DESCRIPTION: "Wpisz 4-cyfrowy kod z SMS-a wysłanego na",
        NO_CODE: "Nie otrzymałeś kodu?",
        RESEND: "Wyślij kod ponownie",
        RESEND_WAIT: "Możesz wysłać kod ponownie za",
        TITLE: "Potwierdź numer telefonu"
    },
    EXIT: {
        DESCRIPTION: "Możesz zapisać dotychczasowe odpowiedzi i wrócić do nich później.",
        RETURN: "Wróć do pytań",
        SAVE: "Zamknij i zapisz",
        TITLE: "Chcesz dokończyć później?"
    }
} as const;

export const getHomeMatchPreferencesWizardSmsDigitLabel = (position: number) => `Cyfra ${position} z 4`;
